export const PERM_CREATE_MULTIPLE_APPOINTMENT = 'CreateMultipleAppointments';
